<template>
  <div class="map-legend-item">
    <div v-if="item.children" class="map-legend-item-group">{{ item.title }}</div>
    <template v-if="item.children">
      <MapLegendItem v-for="child in item.children" :item="child" :layer="layer" />
    </template>
    <div v-else class="flex align-items-center map-legend-item-symbol">
      <div
        v-if="item.style && Object.keys(item.style).length"
        class="layer-icon mr-2"
        :class="getDrawingTypeByLayer(layer)"
        :style="getLayerShapeCss(layer, item.style)"
      ></div>
      <img v-else-if="item.image" :src="item.image" alt="" class="legend-image mr-2" />
      <img v-else-if="item.icon" :src="item.icon" alt="" class="layer-icon mr-2" />
      <div>{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
import { getDrawingTypeByLayer, getLayerShapeCss } from '@/js/utils';

export default {
  name: 'MapLegendItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    layer: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getDrawingTypeByLayer(layer) {
      return getDrawingTypeByLayer(layer);
    },
    getLayerShapeCss(layer, style) {
      return getLayerShapeCss(layer, style);
    },
  },
};
</script>

<style scoped>
.legend-image {
  width: 100%;
  height: 100%;
}
</style>
